import { enhancedApi } from '@store/generated/feedback';

/**
 * Feedback API - extends the generated API with custom configuration
 * This ensures we're using generated types and endpoints
 * while maintaining feature-specific customization
 */
export const feedbackApi = enhancedApi.enhanceEndpoints({
  endpoints: {
    postV2ProviderFeedbackCsat: {
      // No cache invalidation needed for CSAT feedback submissions
    },
  },
});

// Export ONLY user-friendly names (never export verbose names)
export const { usePostV2ProviderFeedbackCsatMutation: useSubmitCSATMutation } = feedbackApi;
